<ng-container *ngIf="vm$ | async as vm">
	<div *ngIf="vm._summaries" class="bg-gray-50 rounded-2xl p-4">
		<h3 class="h3">Sync Docket Summary</h3>
		<h5 class="mt-3">Disbursements Subject to HST</h5>
		<div class="mt-5">
			<h5 class="h5 mb-2">{{ vm.hstTitleDescription }}</h5>
			<div class="w-5/12 whitespace-nowrap">
				{{ vm._summaries.parcel.total_hst_appl | centsToFixedDollars }}
			</div>
		</div>
		<div *ngIf="vm.showHstWrit" class="mt-5">
			<h5 class="h5 mb-2">{{ vm.hstWritDescription }}</h5>
			<div class="w-5/12 whitespace-nowrap">
				{{ vm._summaries.writs.total_hst_appl | centsToFixedDollars }}
			</div>
		</div>

		<div *ngIf="vm.showNonHstTitle" class="border-t mt-5 pt-5">
			<div>
				<h5>Disbursements Not Subject to HST</h5>
				<div class="mt-5">
					<h5 class="h5 mb-2">{{ vm.nonHstTitleDescription }}</h5>
					<div class="w-5/12 whitespace-nowrap">
						{{ vm._summaries.parcel.total_hst_not_appl | centsToFixedDollars }}
					</div>
				</div>
			</div>

			<div *ngIf="vm.showNonHstWrit" class="mt-5">
				<h5 class="h5 mb-2">{{ vm.nonHstWritDescription }}</h5>
				<div class="w-5/12 whitespace-nowrap">
					{{ vm._summaries.writs.total_hst_not_appl | centsToFixedDollars }}
				</div>
			</div>
		</div>

		<div *ngIf="error">
			{{ error }}
		</div>
	</div>
</ng-container>
